import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_ASSOCIATION_LIST = 'GET_ASSOCIATION_LIST';
export const GET_ASSOCIATION_LIST_SUCCESS = 'GET_ASSOCIATION_LIST_SUCCESS';
export const GET_ASSOCIATION_LIST_FAILURE = 'GET_ASSOCIATION_LIST_FAILURE';

// Action Creators
export const fetchGetAssociation = () => ({
  type: GET_ASSOCIATION_LIST,
});

export const fetchGetAssociationSuccess = (data) => ({
  type: GET_ASSOCIATION_LIST_SUCCESS,
  payload: data,
});

export const fetchGetAssociationFailure = (error) => ({
  type: GET_ASSOCIATION_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getAssociationCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAssociation(data, external));
    try {
      const response = await getMethodWithToken(
        url.getAssociationsListSuperAdmin
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAssociationSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAssociationFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAssociationFailure(error.message));
    }
  };
};
